import { render, staticRenderFns } from "./weekplan-classname.vue?vue&type=template&id=09771f6b&"
import script from "./weekplan-classname.vue?vue&type=script&lang=js&"
export * from "./weekplan-classname.vue?vue&type=script&lang=js&"
import style0 from "./weekplan-classname.vue?vue&type=style&index=0&id=09771f6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports